import axios from "axios";
var url_atual = window.location.href;
let index_ = url_atual.indexOf("localhost");
let url_ = "";
if (index_ == -1) {
  //url_ = "https://www.servicos-administrativos.online/servicosadministrativos";
  url_ = "https://www.servicos-administrativos.online/api";
} else {
  //url_ = "https://g-ale.net/apidev/G"
  url_ = "http://localhost:3000";
  // url_="https://g-ale.net/apidev/G"
}
const baseUrl = url_;

// Interceptador para tratar erros globalmente
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK" || error.message.includes("Network Error")) {
      console.warn("Erro de rede:", error.message);
    } else if (error.response?.status === 404) {
      console.warn("Endpoint não encontrado:", error.config?.url);
    }
    return Promise.reject(error);
  }
);

const objectToQueryString = (obj = {}) => {
  var str = [];

  let k = Object.keys(obj);
  k.forEach((iten) => {
    str.push(`${iten}=${obj[iten]}`);
  });

  return str.join("&");
};
const apiPublic = axios.create({
  baseURL: baseUrl,
});
const http = async (method, path, data) => {
  try {
    let retorno = await axios({
      method: method,
      url: baseUrl + path,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenbearer()}`,
      },
    });

    return retorno;
  } catch (error) {
    console.error(`Erro na requisição ${method} ${path}:`, error.message);
    throw error;
  }
};
const httpget = async (path, data) => {
  try {
    const retorno = await axios({
      method: "get",
      url: baseUrl + path + "?" + objectToQueryString(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenbearer()}`,
      },
    });

    return retorno;
  } catch (error) {
    console.error(`Erro na requisição GET ${path}:`, error.message);
    throw error;
  }
};
const httpEX = async (path) => {
  let retorno = await axios({
    method: "get",
    url: path,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return retorno;
};

const tokenbearer = () => {
  let token;
  if (typeof localStorage.token == "undefined") {
    token = "n";
  } else {
    token = localStorage.token;
  }
  return token;
};

/*const https = async (method, path, data) => {
  let res = await axios({
    method: method,
    url: baseUrl + path,
    data: objectToQueryString(data),
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return (response)

}*/
const request = (method, url, data, callback) => {
  axios({
    method: method,
    url: url,
    data: objectToQueryString(data),
  }).then(callback);
};

export { apiPublic, objectToQueryString, http, request, httpget, httpEX };
